import React, {useEffect} from 'react'
import { observer } from "mobx-react-lite"
import { Router } from "@reach/router"
import PrivateRoute from '../features/common/PrivateRoute'
import useUser from '../features/common/useUser'
import InitApp from '../components/InitApp'
import NotFound from '../features/layout/NotFound'
import Index from '../features/index'
import SubscribeModal from '../features/account/SubscribeModal'
import LivePerformance from '../features/catalog/LivePerformance'
import ProducerSounds from '../features/catalog/ProducerSounds'
import Pack from '../features/pack/Pack'
import MyLibrary from '../features/my/MyLibrary'
import Auth from '../features/auth/Auth'
import Settings from '../features/account/Settings'
import VerifyEmail from '../features/account/VerifyEmail'
import ResetPassword from '../features/auth/ResetPassword'
import Faq from '../features/help/faq'
import DrumNet from '../features/welcome/DrumNet'
import TrainModel from '../features/welcome/TrainModel'
import VocalNet from '../features/welcome/VocalNet'
import VocalNetZh from '../features/welcome/VocalNetZh'
import VocalNetTutorial from '../features/welcome/VocalNetTutorial'
import VocalNetCommunity from '../features/welcome/VocalNetCommunity'
import PitchNet from '../features/welcome/PitchNet'
// import DrumNetZh from '../features/welcome/DrumNetZh'
import Packs from '../features/welcome/Packs'
import Reviews from '../features/welcome/Reviews'
import ShortcutsAndFx from '../features/help/shortcuts-and-fx'
import Copyrights from '../features/policies/Copyrights'
import Google from '../features/policies/Google'
import PrivacyPolicy from '../features/policies/PrivacyPolicy'
import PricingTerms from '../features/policies/PricingTerms'
import AcceptableUseAndFairUsagePolicy from '../features/policies/AcceptableUseAndFairUsagePolicy'
import TermsOfService from '../features/policies/TermsOfService'
import PayPlan from '../features/account/PayPlan'
import Checkout from '../features/account/Checkout'
import Share from '../features/share/Share'
import Unsubscribe from '../features/auth/Unsubscribe'
import Pricing from '../features/account/Pricing'
import AppBuy from '../features/account/AppBuy'
import FileUpload from '../features/upload/FileUpload'
import Promo from '../features/promo/Promo'


// 路由
const Routes = observer(() => {
  const { user, init } = useUser()
  useEffect(() => {
    init()
  }, [init, user.auth])

  if (user.auth === 0) {
    return <InitApp />
  }

  return (
    <>
    <SubscribeModal />
    <Router>
      <Index path="/" />
      <LivePerformance path="/catalog/live-performance" />
      <ProducerSounds path="/catalog/producer-sounds" />
      <TrainModel path="/train-model" />
      <VocalNet path="/vocalnet" />
      <VocalNetZh path="/vocalnet/zh" />
      <VocalNetCommunity path="/vocalnet-community" />
      <VocalNetTutorial path="/vocalnet-tutorial" />
      <PitchNet path="/pitchnet" />
      <DrumNet path="/drumnet" />
      {/*<DrumNetZh path="/drumnet/zh" />*/}
      <Packs path="/packs" />
      <PrivateRoute as={Settings} path="/account/*" />
      <PrivateRoute as={PayPlan} path="/account/pay-plan" />
      <PrivateRoute as={Checkout} path="/account/checkout" />
      <PrivateRoute as={AppBuy} path="/account/app-buy" />
      <PrivateRoute as={FileUpload} path="/upload" />
      <Pricing path="/pricing" />
      <Promo path="/promo" />
      {/* <PrivateRoute as={Home} path="/" /> */}
      <Pack path="/pack/:packId" />
      <PrivateRoute as={MyLibrary} path="/my-library" />

      <ResetPassword path="/auth/reset-password" />
      <VerifyEmail path="/auth/verify-email" />
      <VerifyEmail path="/auth/change-email" />
      <Unsubscribe path="/auth/unsubscribe" />
      <Auth path="/auth/*" />

      <TermsOfService path="/policies/terms-of-service" />
      <AcceptableUseAndFairUsagePolicy path="/policies/acceptable-use-and-fair-usage-policy" />
      <Copyrights path="/policies/copyrights" />
      <PricingTerms path="/policies/pricing-terms" />
      <PrivacyPolicy path="/policies/privacy-policy" />
      <Google path="/policies/google" />

      <Faq path="/help/faq" />
      <Reviews path="/reviews" />
      <ShortcutsAndFx path="/help/shortcuts-and-fx" />

      <Share path="/s/:shareCode" />
      <Share path="/i/:shareCode" />

      <NotFound path="/404" />
      <NotFound path="*" />
    </Router>
    </>
  )
})

export default Routes
